const Types = {
  MEAL__GET_HOME_DATA: 'MEAL__GET_HOME_DATA',
  MEAL__GET_PLANS: 'MEAL__GET_PLANS',
  MEAL__GET_MENUS: 'MEAL__GET_MENUS',
  MEAL__SET_MENUS_MODAL: 'MEAL__SET_MENUS_MODAL',
};
export default Types;
